import { ConfigStore } from "../../store/modules/config";
import { OperationVue } from "../operations/OperationVue";
import { getModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";
import IOperationService from "../../services/operations/IOperationService";
import { DiTokens } from "../../services/diTokens";
import { RegisterModel } from "../../models/auth/RegisterModel";

/**Модель представления авторизации */
export class RegisterVue extends OperationVue {
  /** Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Ссылка на правила банка */
  get rulesFile(): string {
    return this.configStore.apiData.RulesFile;
  }

  /**Ссылка на тарифы банка */
  get tarifsFile(): string {
    return this.configStore.apiData.TarifsFile;
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.RegisterService);
    this.OperationModel = (await this.service.init()) as RegisterModel;
    this.loading = false;
  }

  loginDialog: boolean = false;
  loginDialogContent: string = "";

  closeLoginDialog(): void {
    this.loginDialog = false;
    this.$router.push(
      `/login`
    );
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.loginDialogContent = (this.OperationModel as RegisterModel).SuccessMessage;
    this.loginDialog = true;
  }
}
